const { BASE_URL } = require("./client");

const SEND_EMAIL = BASE_URL +'/api/popupchat'

module.exports = {
    SEND_EMAIL
}